import axios from 'axios';
import { X_API_KEY } from '../utils/authentication';

const apiVersion = "v1"
// from the root of the site
let apiUrl = `${window.location.origin}/ledmodulestore/api/${apiVersion}`;
if (process.env.NODE_ENV !== 'production') {
  apiUrl = `http://dev.tuner4tronic.com/ledmodulestore/api/${apiVersion}`;
}

const ledModuleAction = "modules";

function getApiBaseUrl() {
  return apiUrl;
}

export function getLedmodulesApiUrl() {
  return `${apiUrl}/${ledModuleAction}?includeNonPublished=true`;
}

export function getLedmoduleApiUrl(ledModuleId) {
  return `/${ledModuleId}`;
}

export function putLedmoduleApiUrl(ledModuleId) {
  return `/${ledModuleId}`;
}

export function postLedmodulesApiUrl() {
  return  `/`;
}

export function importLedmoduleApiUrl() {
  return `/import`;
}

export function downloadLedmoduleApiUrl(ledModuleId) {
  return `/${ledModuleId}/export`;
}

// function serializeParams(obj) {
//   return Object.entries(obj).map(([key, val]) => val != null ? `${key}=${val}` : `${key}=`).join('&');
// }

const instance = axios.create({
  baseURL: `${getApiBaseUrl()}/${ledModuleAction}`,
  timeout: 30000,
  headers: { 'Access-Control-Allow-Origin': '*', 'CLIENT-ID': "Frontend" }
});

instance.interceptors.request.use(config => {
  if (localStorage.getItem(X_API_KEY) !== null && typeof localStorage.getItem(X_API_KEY) === 'string' && localStorage.getItem(X_API_KEY) !== '') {
    config.headers['X-API-KEY'] = localStorage.getItem(X_API_KEY);
  } else {
    delete config.headers['X-API-KEY'];
  }
  return config;
});

export default instance;

